import TrainingCoursePreviewPage from '../TrainingCourses/PreviewPage';
import {useTranslation} from 'react-i18next';
import usePageMeta from '../../services/page-meta';

export default function TestingPreviewPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('testings.title', 'Testings'),
        description: t('app.description'),
        keywords: t('app.keywords'),
    });

    return <TrainingCoursePreviewPage isTesting={true} />;
}
